module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activity) ? _c('div', {
    staticClass: "speech-container"
  }, [(!_vm.isCurrentUser) ? _c('div', {
    staticClass: "mr-3 pt-1 ml-1"
  }, [_c('ContactImage', {
    attrs: {
      "contact": _vm.currentUser,
      "size": 33
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "speech-bubble",
    class: {
      'current-user': _vm.isCurrentUser, 'other-user': !_vm.isCurrentUser
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activity.description) + "\n    ")]), _vm._v(" "), (_vm.isCurrentUser) ? _c('div', {
    staticClass: "ml-3 pt-1"
  }, [_c('ContactImage', {
    attrs: {
      "contact": _vm.currentUser,
      "size": 33
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37e0ad70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/ui/SpeechBubble.vue
// module id = 2504
// module chunks = 1